/* eslint-disable react/react-in-jsx-scope */
import { Input, Table } from "antd";
import { DV3SearchIcon } from "../../../common/icons";
import HUBContext from "../../../services/HUBContext";
import { VehicleTableCardBase } from "../../Dash/components/v3/vehicleTableCard";
import React, { Suspense } from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import CustomColumns from "../../../helpers/customColumns";
import { withAlert } from "react-alert";
import { withStyles } from "@material-ui/core";
import { setHardFilter } from "../../../common/utils";
import LoaderSpinner from "../../../helpers/LoaderSpinner";
import { ROUTER_MAP_PATH } from "../../../EmbeddedRoutes";
import Error from "../../../helpers/Error";
import CustomPaginatorWidget from "./CustomPaginatorWidget/CustomPaginatorWidget";

const styles = (theme) => ({
  centerContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "450px",
  },
  contentLinks: {
    display: "flex",
    justifyContent: "end",
    gap: "16px",
  },
  contentHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: "600",
    margin: "0px",
  },
  filterAreaSearch: {
    marginTop: "20px",
    marginBottom: "20px",
  },
});

const messages = {
  title: {
    id: "vehicle.table.card.widget.title",
    defaultMessage: "My fleet",
  },
  loadData: {
    id: "vehicle.table.card.widget.load",
    defaultMessage: "Loading data for the selected company...",
  },
  batchUpload: {
    id: "vehicles.table.upload",
    defaultMessage: "Batch Upload",
  },
  syncHitory: {
    id: "vehicles.table.syncHistory",
    defaultMessage: "Sync & History",
  },
  search: {
    id: "vehicles.table.search",
    defaultMessage: "Search",
  },
  error: {
    title: {
      id: "vehicles.table.card.widget.error.title",
      defaultMessage: "We couldn't load data for this company",
    },
    subtitle: {
      id: "vehicles.table.card.widget.error.subtitle",
      defaultMessage:
        "Please try again in a few moments to refresh the information.",
    },
    actionLabel: {
      id: "vehicles.table.card.widget.error.action",
      defaultMessage: "Try again",
    },
  },
  columns: {
    plate: { id: "plate", defaultMessage: "Plate" },
    name: {
      id: "vehicle.name",
      defaultMessage: "Vehicle name",
    },
    status: {
      id: "vehicles.table.status",
      defaultMessage: "Status",
    },
    ownershipStatus: {
      id: "vehicles.table.ownershipStatus",
      defaultMessage: "Ownership status",
    },
    vehicleBrand: {
      id: "vehicleBrand",
      defaultMessage: "Brand",
    },
  },
};

class VehicleTableCardWidget extends VehicleTableCardBase {
  prepareColumnSet() {
    const { intl } = this.props;

    this.columnsSet = [
      {
        dataIndex: "plate",
        title: intl.formatMessage(messages.columns.plate),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "name",
        title: intl.formatMessage(messages.columns.name),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleStatus.name",
        title: intl.formatMessage(messages.columns.status),
        sorter: true,
        width: 170,
        render: (text, record, _) => this.getVehicleStatus(text, record),
      },
      {
        dataIndex: "ownershipStatus.name",
        title: intl.formatMessage(messages.columns.ownershipStatus),
        sorter: true,
        width: 170,
        render: (text, record, _) => this.getOwnershipStatus(text, record),
      },
      {
        dataIndex: "vehicleBrand.name",
        title: intl.formatMessage(messages.columns.vehicleBrand),
        sorter: true,
        width: 170,
      },
    ];
  }

  refreshData() {
    const { response } = this.state;
    const { pageSize, sortProperty, sortDirection } = response || {};

    this.getData(pageSize || 5, 0, sortProperty, sortDirection, "");
  }

  getData = (take, skip, sortProperty, sortDirection, search) => {
    const { response, stateuid } = this.state;
    const { locale, company } = this.context;
    const companyID = company?.companyID || 0;

    let pageSize = take || response?.pageSize || 5;
    let pageIndex = !response?.data ? 0 : parseInt(skip / pageSize);

    const request = {
      pageIndex,
      pageSize,
      search: search ? search : response?.search ? response.search : "",
      sortProperty: sortProperty || "",
      sortDirection: sortDirection || "asc",
      cacheControl: stateuid,
      filters: {
        companyID: companyID,
        ...this.getPrefilters(),
      },
    };

    this.fetchVehicles(companyID, locale, request)
      .then((response) => {
        this.mapResponseData(response);

        this.setState({
          ready: true,
          loading: false,
          error: false,
          response: response.data,
        });
      })
      .catch((error) => {
        this.setState({ ready: true, error: true, loading: false });
      });
  };

  render() {
    const { widget, intl, classes } = this.props;
    const {
      loading,
      error,
      ready,
      response,
      search,
      visibleColumns,
      showCustomizeColumns,
      singleRegistryIsActive,
    } = this.state;
    const { company } = this.context;
    const columns = [...visibleColumns, "_whitespace"].map((c) =>
      this.columnsSet.find((x) => x.dataIndex === c),
    );

    if (loading || !ready || !this.columnsSet) {
      return (
        <div className={classes.centerContainer}>
          <LoaderSpinner info={intl.formatMessage(messages.loadData)} />
        </div>
      );
    }

    if (error) {
      return (
        <div className={classes.centerContainer}>
          <Error
            title={intl.formatMessage(messages.error.title)}
            subtitle={intl.formatMessage(messages.error.subtitle)}
            actionLabel={intl.formatMessage(messages.error.actionLabel)}
            action={() => this.refreshData()}
          />
        </div>
      );
    }

    return (
      <Suspense fallback={<div></div>}>
        <div className={classes.contentHeader}>
          <h3 className={classes.headerTitle}>
            {intl.formatMessage(messages.title)}
          </h3>
          <div className={classes.contentLinks}>
            {singleRegistryIsActive && (
              <Link
                className="v3-button"
                to={ROUTER_MAP_PATH.vehicles.syncHistoryPage?.replace(
                  ":cid",
                  company?.companyID,
                )}
              >
                <span>{intl.formatMessage(messages.syncHitory)}</span>
              </Link>
            )}

            <Link
              className="v3-button"
              to={`${ROUTER_MAP_PATH.vehicles.uploadPage}?skip_solutions=${!singleRegistryIsActive}`?.replace(
                ":cid",
                company?.companyID,
              )}
            >
              <span>{intl.formatMessage(messages.batchUpload)}</span>
            </Link>
          </div>
        </div>

        <div className={`${widget.componentKey}`}>
          <div className="separator-row" style={{ marginTop: "16px" }}></div>

          <div className="filters-area">
            <div className={`filters-area-search ${classes.filterAreaSearch}`}>
              <Input
                value={search}
                onChange={({ target: { value } }) =>
                  this.setState({ search: value })
                }
                onPressEnter={this.onSearchEnter}
                placeholder={intl.formatMessage(messages.search)}
                addonAfter={
                  <DV3SearchIcon
                    onClick={() =>
                      this.onSearchEnter({ target: { value: search } })
                    }
                  />
                }
              />
            </div>
          </div>

          <div className="table-area">
            <Table
              pagination={false}
              scroll={{ x: 500 }}
              dataSource={response?.data || []}
              columns={[...columns.filter((x) => !!x)]}
              onChange={this.onTableChange}
              rowKey={"vehicleID"}
            />

            <CustomPaginatorWidget
              pagerInfo={response}
              onChange={(current) =>
                this.getData(
                  response?.pageSize || 5,
                  (current > 0 ? current - 1 : 0) * (response?.pageSize || 5),
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
              onShowSizeChange={(current, size) =>
                this.getData(
                  size,
                  (current > 0 ? current - 1 : 0) * size,
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
            />
          </div>
        </div>

        <CustomColumns
          visible={showCustomizeColumns}
          columnsSet={this.columnsSet}
          visibleColumns={visibleColumns}
          onCancel={() => this.setState({ showCustomizeColumns: false })}
          onOk={(v) => {
            if (v.length <= 0) return;
            this.setState(
              { visibleColumns: v, showCustomizeColumns: false },
              () => {
                setHardFilter("vehicles-v2-table-columns", v);
              },
            );
          }}
        />
      </Suspense>
    );
  }
}

VehicleTableCardWidget.contextType = HUBContext;
export default withAlert()(
  withStyles(styles)(injectIntl(VehicleTableCardWidget)),
);
